// Copyright © 2021 Move Closer
/**
 * RegExp that looks for the YouTube video  ID in link;
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>, Piotr Niewczas <piotr.niewczas@movecloser.pl>
 */
const getYtVideoIdRegExp = () => /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/gi;
/**
 * Resolves the video ID form the passed-in URL address.
 *
 * @param url - Full _YouTube_ video URL.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const resolveVideoIdFromUrl = (url) => {
    if (url.indexOf('http') === -1) {
        throw new Error(`resolveVideoIdFromUrl(): Provided [url] argument is not a valid URL address!\nArgument's value: [${url}].`);
    }
    const matches = getYtVideoIdRegExp().exec(url);
    if (matches === null) {
        throw new Error(`resolveVideoIdFromUrl(): Provided [url] argument is not a valid YouTube video URL address!\nThere's no [v] param in the provided URL!\n Argument's value: [${url}].`);
    }
    return matches[1];
};
/**
 * Generates the embed code for the passed-in _YouTube_ video URL.
 *
 * @param video - Full URL of just the ID of the target _YouTube_ video.
 * @param [size] - Additional size declaration for the generated `<iframe>`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const generateYtEmbed = (video, size) => {
    let height = '100%';
    let width = '100%';
    if (typeof size === 'object') {
        if (typeof size.height === 'string' && size.height.length > 0) {
            height = size.height;
        }
        if (typeof size.width === 'string' && size.width.length > 0) {
            width = size.width;
        }
    }
    const videoId = video.indexOf('http') !== -1
        ? resolveVideoIdFromUrl(video)
        : video;
    return `<iframe width="${width}" height="${height}" src="https://www.youtube.com/embed/${videoId}" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
};
